import type { FaireProductEntity } from "../../entity_types/product";

export const p_fa653r4x4x: FaireProductEntity = {
  token: "p_fa653r4x4x",
  type: "product",
  name: "Organic Basil Almond Pesto",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/a9433501cc96b264a7ee8e6ffbf41cf7fd4f888154228b198341b962454fb9f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f46987ec0114d1d36d30dcfa97de852b79253a2a745648a1fcc818d019b3c5a.jpeg",
    "https://cdn.faire.com/fastly/8d8b0f233d8e3be5fcf693a4a62f0b21a2c722034f215a4ddd8ae9a91e8fe66e.jpeg"
  ],
  priceDollars: 5.98,
  description: "First created in Genoa, the famous pesto alla genovese is aptly named after its method of production. The enlightened combination of fresh basil, garlic, olive oil, nuts, and cheese were pounded (pestare in Italian) together in a stone mortar with a wooden pestle until a beautifully smooth and delicious paste was achieved. Enjoy our rendition using hardy Sicilian almonds.",
  tags: [],
  msrpDollars: 11.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:22.659Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
